import comp from "./UIInputList";
export default comp;
